import ErplyAPI from 'service/ErplyAPI';

// eslint-disable-next-line import/prefer-default-export
export const getServiceEndpoints = () =>
  ErplyAPI.request('getServiceEndpoints');
